import React from "react";

import styles from "./portal_booking_step_1.module.css";
import { PortalBookingStepLayout } from "./portal_booking_step_layout";
import { Spacer } from "../../spacer";
import { useMediaQuery } from "../../../hooks";
import { SpaceType } from "../../../data";
import { PulseLoader } from "../../../components/pulse_loader";
import { isNumber } from "lodash";
import { UsedPassCountBar } from "@/offering/used_pass_count_bar";

interface PortalBookingStep1Props {
  title: string;
  description?: string;
  warningMessage: string;
  usedCount: number;
  totalCount?: number;
  selectedCount: number;
  rightContent: JSX.Element;
  unitPrice?: string;
  spaceType?: SpaceType;
}

export function PortalBookingStep1({
  title,
  description,
  warningMessage,
  usedCount,
  totalCount,
  selectedCount,
  rightContent,
  unitPrice,
  spaceType,
}: PortalBookingStep1Props) {
  const { device } = useMediaQuery();

  const usedPlusSelected = usedCount + selectedCount;
  const isOverTotalCount = usedPlusSelected > Number(totalCount);

  const show0Remaining = usedCount >= Number(totalCount);

  return (
    <PortalBookingStepLayout
      leftContent={
        show0Remaining ? (
          <div>
            {unitPrice ? (
              <div className={styles.title}>
                {unitPrice}/{spaceType === "meeting_room" ? "hour" : "day"}
              </div>
            ) : (
              <PulseLoader />
            )}
            <Spacer size={8} />
            <div>
              You have 0 membership{" "}
              {spaceType === "meeting_room" ? "hours" : "passes"} remaining.
            </div>
          </div>
        ) : (
          <div>
            <div className={styles.title}>{title}</div>
            {description && (
              <>
                <Spacer size={8} />
                <div>{description}</div>
              </>
            )}
            {isNumber(totalCount) && (
              <>
                <Spacer size={device === "mobile" ? 24 : 32} />
                <UsedPassCountBar
                  usedCount={isOverTotalCount ? totalCount : usedPlusSelected}
                  totalCount={totalCount}
                />
              </>
            )}
            {isOverTotalCount && (
              <div>
                <Spacer size={24} />
                <div className={styles.chargeWarning}>{warningMessage}</div>
              </div>
            )}
          </div>
        )
      }
      rightContent={rightContent}
    />
  );
}
